import apiCreator from './util/ApiCreator';
import exportCreator from './util/ExportCreator';

const endPoint = '/api/dealer-portal/order-search';
const api = apiCreator(endPoint);

export default {
    search (request) {
        return api.post('/', request);
    },
    bulkAuthAction (request) {
        return api.post('/bulk-auth-action', request);
    },
    bulkCancel (request) {
        return api.post('/bulk-cancel', request);
    },
    exportOrders : exportCreator(`${endPoint}/export`),
}
